import React from 'react';
import './ProjectList.css';
import { formatBytes, formatDate } from '../lib/format';

function ProjectList({
  projects,
  selectedProject,
  onSelectProject,
  onRenameProject,
  onDeleteProject,
}) {
  return (
    <ul className="project-list">
      {projects.map((project) => {
        const isActive = selectedProject?.id === project.id;
        return (
          <li key={project.id}>
            <button
              type="button"
              className={`project-item ${isActive ? 'active' : ''}`}
              onClick={() => onSelectProject(project)}
            >
              <span className="project-item-main">
                <span className="project-item-name">
                  {project.name}
                  {project.restored ? <em className="restored-tag"> recovered</em> : null}
                </span>
                <span className="project-item-desc">
                  {project.imageCount || 0} files · {formatBytes(project.storageBytes)} · {formatDate(project.updatedAt)}
                </span>
              </span>
            </button>
            <button
              type="button"
              className="project-item-rename"
              onClick={(e) => {
                e.stopPropagation();
                onRenameProject(project);
              }}
              title="Rename project"
              aria-label={`Rename ${project.name}`}
            >
              ✎
            </button>
            <button
              type="button"
              className="project-item-delete"
              onClick={(e) => {
                e.stopPropagation();
                onDeleteProject(project.id);
              }}
              title="Delete project"
              aria-label={`Delete ${project.name}`}
            >
              ×
            </button>
          </li>
        );
      })}
    </ul>
  );
}

export default ProjectList;
